export function normalizeSearchValue(value: string): string {
  return value
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

function scoreSubsequenceMatch(name: string, query: string): number | null {
  let queryIndex = 0;
  let gapCount = 0;
  let started = false;

  for (let nameIndex = 0; nameIndex < name.length; nameIndex += 1) {
    if (queryIndex >= query.length) {
      break;
    }

    if (name[nameIndex] === query[queryIndex]) {
      queryIndex += 1;
      started = true;
      continue;
    }

    if (started) {
      gapCount += 1;
    }
  }

  if (queryIndex < query.length) {
    return null;
  }

  return gapCount / (query.length + 1) + (name.length - query.length) / 200;
}

export function scoreNameMatch(name: string, query: string): number | null {
  const normalizedName = normalizeSearchValue(name);
  const normalizedQuery = normalizeSearchValue(query);

  if (!normalizedName) {
    return null;
  }

  if (!normalizedQuery) {
    return 10;
  }

  if (normalizedName === normalizedQuery) {
    return 0;
  }

  if (normalizedName.startsWith(normalizedQuery)) {
    return 1;
  }

  const words = normalizedName.split(/\s+/);
  const wordPrefixIndex = words.findIndex((word) => word.startsWith(normalizedQuery));
  if (wordPrefixIndex >= 0) {
    return 2 + wordPrefixIndex / 100;
  }

  const includesIndex = normalizedName.indexOf(normalizedQuery);
  if (includesIndex >= 0) {
    return 3 + includesIndex / 100;
  }

  const subsequenceScore = scoreSubsequenceMatch(normalizedName, normalizedQuery);
  if (subsequenceScore !== null) {
    return 4 + subsequenceScore;
  }

  return null;
}
